import crypto from '../crypto-browserify';

const jose = require('node-jose');
const NodeRSA = require('node-rsa');

export const JWE_KEY = 'jwe_key';
export const KEYSTORE = 'keystore';

const serverPublicKey = 'MIIBCgKCAQEAgczn38xQfPMxcd2GH3APGw3e4o9hg3CB4OKRZ/d8T/1LDShfuG4jxqL1w/6GnG0poH1K0uyV6e6J6e6En4qMtrvyJDiFAqWQPjBIlpb6V8/j/DEWsmzzVgMAOkdNHrxLphktqjQSD+l3TK1fWVAfUoDQSzqSsqLqFSGH2Yhdrgv5K0aHW9kr5JrzEMTswEVQy6bE0f3ig6Syp0/2CX9ol/TbM0knp+dPqHoQPBNl+r1HGHDNJ3ukvP7zFvGgQnPym27owNytlrKJtJK6nf+DQcArCoSt2CbJI48xw7E2yTmRCrGxRKkoMtiS6RN05eYxs9u+Eldhm6mOBcQI7iEOoQIDAQAB';

const key = new NodeRSA();

/**
 *
 * @param len
 * @returns {string} random hex string generated
 */
const randHex = (len) => {
  const maxlen = 8;
  // eslint-disable-next-line no-restricted-properties
  const min = Math.pow(16, Math.min(len, maxlen) - 1);
  // eslint-disable-next-line no-restricted-properties
  const max = Math.pow(16, Math.min(len, maxlen)) - 1;
  const n = Math.floor(Math.random() * (max - min + 1)) + min;
  let r = n.toString(16);
  while (r.length < len) {
    r += randHex(len - maxlen);
  }
  return r;
};

const hex = randHex(32);


export const getTransKey = () => {
  key.setOptions({ encryptionScheme: 'pkcs1' });
  key.importKey(serverPublicKey, 'pkcs1-public');

  const encryptData = key.encrypt(hex, 'hex', 'hex');

  return {
    encrypted: encryptData.toString(),
    clair: hex,
  };
};

export const aes128gcm = (keyClair) => {
  const ALGO = 'aes-128-gcm';

  const decrypt = (enc, iv, authTag) => {
    try {
      const decipher = crypto.createDecipheriv(ALGO, keyClair, Buffer.from(iv, 'hex'));
      decipher.setAuthTag(authTag);
      let decrypted = decipher.update(enc, 'hex', 'hex');
      decrypted += decipher.final('hex');

      return decrypted;

    } catch (error) {
      console.error('Decryption failed:', error);
      throw error;
    }
  };
  return {
    decrypt,
  };
};

export const getBufferHex = (data) => Buffer.from(data, 'hex');


export const getJwkKeystore = async (hashKey = localStorage.getItem(JWE_KEY) ?? '') => {
  const base64UrlKey = getBufferHex(hashKey).toString('base64');

  const keystore = jose.JWK.createKeyStore();
  await keystore.add({
    kty: 'oct',
    k: base64UrlKey,
    key_ops: ['wrapKey', 'unwrapKey'],
    kid: 'otalent_key',
    use: 'enc',
  });
  return keystore;
};


export const jweDecryption = async (data, keystore) => {
  try {
    const result = await jose.JWE.createDecrypt(keystore).decrypt(data);
    const payload = result.payload.toString('utf8');
    return JSON.parse(payload);
  } catch (e) {
    //localStorage.clear();
    //window.location.href = '/login';

  }
};

export const jweEncryption = async (data, keystore) => {
  keystore = keystore.toJSON(true)
  const keyObject = keystore.keys.find(key => key.kid === 'otalent_key');
  return jose.JWE.createEncrypt({ key: keyObject, alg: 'A128KW',enc: 'A128CBC-HS256'})
    .update(Buffer.from(JSON.stringify(data)))
    .final()
    .then((result) => {

      return `${result.protected}.${result.recipients[0].encrypted_key}.${result.iv}.${result.ciphertext}.${result.tag}`;
    });
};


